import api from '@/api';

export default {
  buscarTitularidade: venda => api.get(`ticket/${venda}`),
  salvarTitularidade: dados => api.post('ticket', dados),
};
